module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "software-item"
  }, [_c('img', {
    staticClass: "software-icon",
    attrs: {
      "src": _vm.software.iconUrl || 'https://dummyimage.com/48x48/595b75/fff'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "software-name"
  }, [_vm._v(_vm._s(_vm.software.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-392d2fa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/software-item/index.vue
// module id = 1992
// module chunks = 2